<template>
    <div v-show="visible">
        <el-dialog
            title="同步第三方记录"
            :close-on-click-modal="false"
            :visible.sync="visible"
            width="1100px"
            :modal="false"
            append-to-body
            :before-close="handleClose"
        >
            <div style="margin-bottom:10px;">
                <el-input v-model="queryForm.className" placeholder="年级/班级名称" clearable style="width: 130px;"></el-input>
                <el-input v-model="queryForm.studentName" placeholder="学生姓名" clearable style="width: 110px;margin-left:10px;"></el-input>
                <el-select v-model="queryForm.type" placeholder="类型" clearable style="width: 100px;margin-left:10px;">
                    <el-option :value="1" label="学生"></el-option>
                    <el-option :value="2" label="学生头像"></el-option>
                    <el-option :value="3" label="家长"></el-option>
                    <el-option :value="4" label="年级"></el-option>
                    <el-option :value="5" label="班级"></el-option>
                </el-select>
                <el-select v-model="queryForm.operateType" placeholder="操作类型" clearable style="width: 140px;margin-left:10px;">
                    <el-option :value="1" label="新增"></el-option>
                    <el-option :value="2" label="修改"></el-option>
                    <el-option :value="3" label="删除"></el-option>
                </el-select>
                <el-date-picker
                    v-model="queryForm.gmtCreateRange"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="操作开始时间"
                    end-placeholder="操作结束时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="timestamp"
                    style="width: 360px;margin-left:10px;"
                    clearable>
                </el-date-picker>
                <el-button type="primary" icon="search" @click="common.page=1;getData()" style="margin-left:10px;">查询</el-button>
                <el-button @click="resetQuery" style="margin-left:6px;">重置</el-button>
            </div>

            <el-table
                :data="records"
                v-loading="loading"
                element-loading-text="数据正在加载中..."
                element-loading-background="rgba(255, 255,255,0.7)"
                border
                height="520"
            >
                <el-table-column label="序号" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (common.page - 1) * common.pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="className" label="年级/班级名称" min-width="180" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="studentName" label="学生姓名" width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="类型" width="110">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">学生</span>
                        <span v-else-if="scope.row.type == 2">学生头像</span>
                        <span v-else-if="scope.row.type == 3">家长</span>
                        <span v-else-if="scope.row.type == 4">年级</span>
                        <span v-else-if="scope.row.type == 5">班级</span>
                        <span v-else>{{scope.row.type}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作类型" width="110">
                    <template slot-scope="scope">
                        <span v-if="scope.row.operateType == 1">新增</span>
                        <span v-else-if="scope.row.operateType == 2">修改</span>
                        <span v-else-if="scope.row.operateType == 3">删除</span>
                        <span v-else>{{scope.row.operateType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="gmtCreate" label="操作时间" width="180">
                    <template slot-scope="scope">
                        {{ formatGmtCreate(scope.row.gmtCreate) }}
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination" style="margin-top:10px;text-align:right;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible:false,
                loading:false,
                schoolId:"",
                records:[],
                common:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100],
                },
                queryForm:{
                    className:"",
                    studentName:"",
                    type:"",
                    operateType:"",
                    gmtCreateRange:[]
                }
            }
        },
        methods:{
            init(row){
                this.visible = true;
                this.loading = false;
                this.schoolId = this.$util.isNotEmpty(row) && this.$util.isNotEmpty(row.id) ? row.id : "";
                this.common.page = 1;
                this.resetQuery(false);
                this.getData();
            },
            handleClose(done){
                this.visible = false;
                this.$emit('closed');
                done();
            },
            resetQuery(needReload = true){
                this.queryForm.className = "";
                this.queryForm.studentName = "";
                this.queryForm.type = "";
                this.queryForm.operateType = "";
                this.queryForm.gmtCreateRange = [];
                if(needReload){
                    this.common.page = 1;
                    this.getData();
                }
            },
            formatGmtCreate(val){
                if(this.$util.isEmpty(val)){
                    return "";
                }
                return this.$commonFn.formatDate(val, 'Y-M-D H:I:S');
            },
            toTimestamp(val){
                if(this.$util.isEmpty(val)){
                    return "";
                }
                if(typeof val === 'number'){
                    return val;
                }
                if(typeof val === 'string'){
                    if(/^[0-9]+$/.test(val)){
                        return parseInt(val);
                    }
                    let t = new Date(val.replace(new RegExp(/-/gm), '/')).getTime();
                    return isNaN(t) ? "" : t;
                }
                let t = new Date(val).getTime();
                return isNaN(t) ? "" : t;
            },
            getData(){
                this.loading = true;
                let url = this.deptThirdSyncRecordListUrl;
                let startTime = "";
                let endTime = "";
                if(this.$util.isNotEmpty(this.queryForm.gmtCreateRange) && this.queryForm.gmtCreateRange.length === 2){
                    startTime = this.toTimestamp(this.queryForm.gmtCreateRange[0]);
                    endTime = this.toTimestamp(this.queryForm.gmtCreateRange[1]);
                }
                let data = {
                    isPage:this.common.isPage,
                    currentPage:this.common.page,
                    limit:this.common.pageSize,
                    schoolId: this.schoolId,
                    className: this.queryForm.className,
                    studentName: this.queryForm.studentName,
                    type: this.queryForm.type,
                    operateType: this.queryForm.operateType,
                    startTime,
                    endTime
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.records = res.data.data;
                        this.common.total = res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/dept/ThirdSyncRecord.vue